import { Value } from 'slate';
import HtmlSerializer from 'slate-html-serializer';
import writtenNumber from 'written-number';

import { createRules } from '../createRules';
import { plLocale } from '../locale/pl';
import { deLocale } from '../locale/de';

export * from './getSchema';
export * from './getTemplateVariablesValues';

/**
 * Render template preview
 *
 * @param template - template object
 * @param nestedPath - nested path for the template. When provided, it will be used to set the template variables values in provided path
 * @returns {*}
 */
export const renderTemplatePreview = (template, nestedPath = '') => {
  const slateObject = template && Value.fromJSON(template);
  const rules = createRules(template, slateObject, nestedPath);
  const serializer = new HtmlSerializer({ rules });

  return serializer.serialize(slateObject, { render: false });
};

export const moneyToWords = (number, currency, langCode = 'pl') => {
  if (!parseFloat(number)) return '';

  let lang = 'en';
  if (langCode === 'pl') lang = plLocale;
  else if (langCode === 'de') lang = deLocale;

  const numberString = number.toString();
  if (!numberString.includes('.')) {
    return `(${writtenNumber(number, { lang })}) ${currency}`;
  }

  const [dollars, cents] = numberString.split('.');
  return `(${writtenNumber(Number(dollars), { lang })} ${cents}${
    cents.length === 1 ? '0' : ''
  }/100) ${currency}`;
};

export const getVariableName = (variable, loopWrapperIndex) => {
  if (!variable) {
    return undefined;
  }

  if (variable.list && loopWrapperIndex !== null) {
    return variable.name + `.${loopWrapperIndex}`;
  } else if (variable.list) {
    // Fallback for situation when we not have loopWrapperIndex
    // probably because the user is using a variable with a loop variable outside the loop
    return variable.name + `.0`;
  }

  return variable.name;
};
